import { render } from "./App.vue?vue&type=template&id=619984cc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=619984cc&lang=less"

import exportComponent from "E:\\Samples\\学习\\WebPackTest\\my-diary\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__